module.exports = __webpack_public_path__ + "static/media/dixon_color.b36d2a25.jpg";